export const VERSION = {
    "version": "3.6.2"
};
